import React from 'react'

const SQL = () => {
  return (
    <div>
        {/* collapseTwo */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingTwo">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                    aria-expanded="false" aria-controls="collapseTwo">
                    SQL, PL-SQL
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                      <li>Introduction to SQL</li>
                      <li>Installation of SQL setup</li>
                      <li>SQL Table - Create, Drop, Alter, etc.</li>
                      <li>SQL operations on select, Clause, Order By, Insert, Delete, Update, etc. queries</li>
                      <li>SQL Joins, Keys, Indexes</li>
                      <li>SQL - Sub Queries</li>
                      <li>Normalization - 1NF, 2NF, 3NF, etc.</li>
                      <li>PL SQL - Control Statements, Triggers, Functions, Stored Procedures</li>
                      <li>Indexing - Clustered, Non-Clustered, etc.</li>
                      <li>Cursor</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default SQL